/**
 * @file 所属 Family 一覧を 1 回だけ取得する hook。
 * @failure: 取得失敗は `status: "error"` に落とし、詳細は console にのみ残す。
 */

import { useEffect, useState } from "react";
import { fetchMyFamilies, type MyFamily } from "../api/families";

export type MyFamiliesState =
  | { status: "loading" }
  | { status: "ready"; families: MyFamily[] }
  | { status: "error" };

export function useMyFamilies(): MyFamiliesState {
  const [state, setState] = useState<MyFamiliesState>({ status: "loading" });

  useEffect(() => {
    const controller = new AbortController();
    setState({ status: "loading" });
    fetchMyFamilies(controller.signal)
      .then((families) => {
        if (!controller.signal.aborted) setState({ status: "ready", families });
      })
      .catch((err: unknown) => {
        if (controller.signal.aborted) return;
        console.error("[study] failed to load families", err);
        setState({ status: "error" });
      });
    return () => controller.abort();
  }, []);

  return state;
}
